const serverUrl = process.env.PENTA_MASTER_SERVER_URL || `https://${window.location.hostname}/api/`;

export const AUTH_LOGIN = serverUrl + 'auth/login';
export const AUTH_LOGIN_PERMISSIONS = serverUrl + 'auth/login-permissions';